import React, { useCallback, useEffect, useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary, {
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import Session from './Session';
import { tokens } from '../../../layout/theme';
import API from '../../../config/API';
import { useAuthContext } from '../../auth/hooks/useAuthContext';
import Skeleton from '../../dashbord/components/helpers/Skeleton';

const Accordion = styled((AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...AccordionProps} />
))(({ theme }) => ({
    //border: `1px solid ${theme.palette.divider}`,
    borderRadius: '5px',
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((AccordionSummaryProps) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...AccordionSummaryProps}
    />
))(({ theme }) => ({
    // backgroundColor: theme.palette.background.default,
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export default function CourseSections({ course_id, teacherUserId }) {
    const { user } = useAuthContext() || JSON.parse(localStorage.getItem("user"));
    const [expanded, setExpanded] = useState('panel0');
    const [sections, setSections] = useState([])
    const [resolvedTeacherUserId, setResolvedTeacherUserId] = useState(teacherUserId);
    const [loading, setLoading] = useState(false);
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const handleChange =
        (panel) => (event, newExpanded) => {
            setExpanded(newExpanded ? panel : false);
        };

    const normalizeCourseSections = (courseData) => {
        const categorizedSections = courseData?.session_categorized_by_section || [];
        return categorizedSections.map((section) => ({
            ...section,
            sessions: section.sessions || section.session || [],
        }));
    };

    const getSectionsData = useCallback(() => {
        if (!user?.token || !course_id || course_id === 'undefined') {
            return;
        }

        setLoading(true)
        API.get(`get_content_course_details?course_id=${course_id}`, {
            headers: {
                Authorization: user.token,
                "Content-Type": 'application/json'
            }
        }).then(response => {
            const courseData = response?.data?.data?.[0];
            if (response.status === 200 && courseData) {
                setResolvedTeacherUserId(courseData.teacher_id || teacherUserId);
                setSections(normalizeCourseSections(courseData));
            } else {
                throw Error('Someting wrong happened')
            }
            setLoading(false)
        }).catch(err => { console.log("the error is ", err); setLoading(false) })
    }, [course_id, teacherUserId, user?.token])

    useEffect(() => {
        if (user && course_id) getSectionsData()
    }, [user, course_id, getSectionsData])
    return (
        <>
            {(loading && !sections.length) ? <>
                {Array(1).fill().map((_, index) => <Skeleton key={index} width={'80vw'} height={'60vh'} />)}
            </> :
                <Box>
                    {sections.length > 0 &&
                        <>
                            {sections.map((section, index) => (
                                <Accordion key={index} expanded={expanded === 'panel' + index} onChange={handleChange('panel' + index)} sx={{ backgroundColor: index % 2 === 0 ? colors.primary[200] : theme.palette.background.gray }}>
                                    <AccordionSummary aria-controls={`panel${index}d-content`} id={`panel${index}d-header`}>
                                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', width: '100%' }}>
                                            <Typography variant='h3' sx={{ color: theme.palette.text.default, margin: '0px 20px' }}>{section.title}</Typography>
                                        </Box>

                                    </AccordionSummary>
                                    <AccordionDetails >
                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                            {section.sessions.map((session) => (
                                                <Session data={session} key={session.id} courseId={section.course_id} teacherUserId={resolvedTeacherUserId || teacherUserId} />
                                            ))}
                                        </Box>

                                    </AccordionDetails>
                                </Accordion>
                            ))}
                        </>
                    }
                </Box>}
        </>

    );
}
